import { MyHttpClient } from '../../http-client.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "../../http-client.service";
var HostGeneralInfoService = /** @class */ (function () {
    function HostGeneralInfoService(http) {
        this.http = http;
        this.server = "" + environment.server;
        this.hostVehicleDetails = this.server + '/api/getHostVehicleDetails';
    }
    HostGeneralInfoService.prototype.getHostVehicleDetails = function (id) {
        return this.http.get(this.hostVehicleDetails + '/' + id).pipe(catchError(this.handleError));
    };
    HostGeneralInfoService.prototype.getReferralSummary = function (profileId) {
        return this.http.get(this.server + "/api/pool-manager/profiles/" + profileId + "/referrals/summary").pipe(catchError(this.handleError));
    };
    HostGeneralInfoService.prototype.getHoprMetrics = function (profileId) {
        return this.http.get(this.server + "/api/svo/captain/hopr/metrics/" + profileId).pipe(catchError(this.handleError));
    };
    HostGeneralInfoService.prototype.handleError = function (error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error("Backend returned code " + error.status + ", " +
                ("body was: " + error.error));
        }
        // return an observable with a user-facing error message
        return throwError(error);
    };
    HostGeneralInfoService.ngInjectableDef = i0.defineInjectable({ factory: function HostGeneralInfoService_Factory() { return new HostGeneralInfoService(i0.inject(i1.MyHttpClient)); }, token: HostGeneralInfoService, providedIn: "root" });
    return HostGeneralInfoService;
}());
export { HostGeneralInfoService };
